
import { useImperativeHandle, forwardRef, useRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import uuid from 'react-uuid';
import { Modal } from 'bootstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Loader from '../../../components/ui/Loader/Loader';
import TapSelect from '../../../components/ui/TapSelect';
import TapIcon from '../../../services/TapIcon';
import HttpAPICall from '../../../services/HttpAPICall';
import { IAM_API_BASE_URL_2, INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { toast } from 'react-toastify';

const ListTermConditionModal = forwardRef((props, ref) => {
    const [modalListId, setModalListId] = useState(uuid());
    const [searchTNCByTags, setSearchTNCByTags] = useState([]);

    const modalListElem = useRef(null);
    const modal = useRef(null);

    useImperativeHandle(ref, () => ({

        listTermConditionModalInit: () => {
            openModalHandler();
        }
    }));

    const modalOpen = () => {
        if (modal.current) { modal.current.show(); }
    }

    const modalClose = () => {
        if (modal.current) { modal.current.hide(); }
    }

    useEffect(() => {
        props.getTermListing()
        props.pickTermsInit()
        modalListElem.current = document.getElementById(modalListId);
        modal.current = new Modal(modalListElem.current, { keyboard: false, backdrop: false });
        return () => {
            if (modal.current) {
                modal.current.dispose();
            }
        };

    }, []);


    const openModalHandler = () => {
        modalOpen();
    }



    const addTncInPO = (k) => {
        let selectedTnc = props.termCoditions[k];
        if (selectedTnc) {
            props.setFormData(prevFormData => ({
                ...prevFormData,
                tnc: [...(prevFormData.tnc || []), { ...selectedTnc, id: '', editMode: false }]
            }));
        }
    }

      const searchTNCHandle  = (selectedOption) => {
 
        if(selectedOption.length > 0) {
            const tags = selectedOption.map(tag => tag.value);
            const termCoditionsData = props.oldTNC;

    
            let tcData = termCoditionsData.filter(item => item.tags.some(tag => tags.includes(tag.id))).filter((tc, index, tcDataArr) => index === tcDataArr.findIndex(t => t.name === tc.name));
             setSearchTNCByTags(tags)
             props.setTermCoditions(tcData)
                 
        }else {
            setSearchTNCByTags([])
            props.setTermCoditions(props.oldTNC)
        }
        

    }

    return <>
        <div className="modal fade" id={modalListId} tabIndex="-1" ref={modalListElem}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Terms & Condition</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <div className="modal-body">
                            {
                                props.pickTNCModalLoader
                                    ?
                                    <Loader />
                                    :
                                    <>
                                        <div className="row align-items-center">
                                            <div className="col-sm-6">
                                            </div>
                                            <div className="col-sm-6">
                                                <TapSelect
                                                    options={props.tncTags}
                                                    changeEvent={(selectedOption) => searchTNCHandle(selectedOption)}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    value={props.tncTags.filter(s => searchTNCByTags.includes(s.value))}
                                                    isMulti={true}
                                                    placeholder="Select Tag"
                                                    containerHeight="32px"
                                                    fontSize="93%"
                                                />
                                            </div>
                                        </div>
                                        <table className="table table-bordered table-responsive bg-white my-2" id="poTermTable">
                                            <thead className="table-secondary">
                                                <tr className="text-center">
                                                    <th scope="col" className="text-start" style={{ width: "20%" }}>Name</th>
                                                    <th scope="col" className="text-start" style={{ width: "50%" }}>Description</th>
                                                    <th scope="col" style={{ width: "20%" }}>Tag</th>
                                                    <th scope="col" className="text-start" style={{ width: "10%" }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {props.termCoditions ? props.termCoditions?.map((tnc, k) => {
                                                    let picked = props.formData?.tnc?.find((potnc) => potnc.name == tnc.name);
                                                    return <tr key={k}>
                                                        <td>{tnc.name}</td>
                                                        <td dangerouslySetInnerHTML={{ __html: tnc.text }} />
                                                        <td>{tnc.tags.length > 0 &&
                                                            tnc.tags.map(tag => tag.name).join(', ')
                                                        }
                                                        </td>
                                                        <td className="text-center">
                                                            <button
                                                                disabled={picked}
                                                                onClick={() => addTncInPO(k)}
                                                                className={["btn", "py-1", "px-3", picked ? "btn-light" : "btn-secondary"].join(' ')}
                                                            >{picked
                                                                ? <TapIcon.FontAwesomeIcon color="green" icon={TapIcon.faCheck} />
                                                                : 'Pick'}
                                                            </button>
                                                        </td>
                                                    </tr>
                                                }) :
                                                    <tr>
                                                        <td className="text-center" colSpan={4}>
                                                            No Record Found
                                                        </td>
                                                    </tr>}
                                            </tbody>
                                        </table>
                                    </>
                            }

                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button"
                            className="btn btn-secondary mx-2"
                            data-bs-dismiss="modal"
                        >Close</button>
                    </div>
                </div>
            </div>
        </div>
    </>
});

export default ListTermConditionModal;